import { ILocalizedMenuEntry } from 'state/unified-menu/types';

import { MultipliersSelections } from '../../product-wizard/types';
import { IModifier } from '../modifier/types';

export type CustomizationRenderItem = {
  item: ILocalizedMenuEntry;
  index: number;
  rowIndex: number;
};

// Order Matters for UI!
export enum DrinkCategory {
  SOFTS,
  SHAKES,
  FROZENS,
  OTHERS,
}

export enum ComboSlotType {
  DRINKS = 'drinks',
  SIDES = 'sides',
  PICKER_ASPECT = 'pickerAspect',
}

export type SelectModifierFn = (selections: MultipliersSelections, modifier: IModifier) => void;
